import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ErrorInfoProps, Menu, Notifications, SwitchErrorInfo } from 'piral';
import SignInButton from './ms-identity/SignInButton';
import SignOutButton from './ms-identity/SignOutButton';
import SwitchInButton from './ms-identity/SwitchInButton';
import SwitchOutButton from './ms-identity/SwitchOutButton';
import useCurrentPilet from './hooks/useCurrentPilet';
import { Container, Row, Col, Dropdown, DropdownToggle, LinkList, DropdownMenu, LinkListItem, Icon, NavLink, Badge } from 'design-react-kit';
import logo from './assets/stemma_giglio.png';
import { useAuth } from './ms-identity/AuthContext';

export const errors = {
    not_found: () => (
        <div>
            <p className="error">La pagina non è stata trovata. Sei sicuro che esista?</p>
            <p>Torna alla <Link to="/">home</Link>.</p>
        </div>
    ),
};

export const layout = {
    ErrorInfo: (props: React.JSX.IntrinsicAttributes & ErrorInfoProps) => (
        <div>
            <h1>Error</h1>
            <SwitchErrorInfo {...props} />
        </div>
    ),
    DashboardContainer: ({ children }) => {
        const [graphData, setGraphData] = useState(null);
        const { isAuthenticated, user, switched } = useAuth();

        function requestProfileData() {
            setGraphData(user);
        }

        return (
            <div>
                {
                    isAuthenticated ? (
                        graphData ? (
                            <>
                                <h1>Salve {graphData.givenName ?? graphData.given_name} {switched ? <Badge style={{ fontSize: 24, verticalAlign: 'middle' }} color="warning">
                                    Switched
                                </Badge> : ""} </h1>
                                <div className="tiles">
                                    {children}
                                </div>
                            </>) : requestProfileData() as null
                    ) : <p>Benvenuto, accedi per continuare</p>
                }
            </div>
        );
    },
    DashboardTile: ({ columns, rows, children }) => <div className={`tile cols-${columns} rows-${rows}`}>{children}</div>,
    Layout: ({ children }) => (
        <div>
            <Notifications />
            <Menu type="general" />
            <div className="container mt-3">{children}</div>
        </div>
    ),
    MenuContainer: ({ children }) => {
        const { isAuthenticated, switched, real_user } = useAuth();
        const currentPilet = useCurrentPilet();

        return (
            <header>
                <nav className="navbar navbar-light navbar-expand-lg navbar-toggleable-lg ng-white box-shadow">
                    <div className="container">
                        <div>
                            <img src={logo} className="icon img-fluid" style={{ paddingBottom: '2px', width: '32px', height: 'auto' }}></img>
                            <Link className="navbar-brand text-white" to="/" style={{ marginLeft: '15px', fontSize: '20px' }}>
                                Leonardo
                            </Link>
                        </div>
                        {
                            currentPilet ? (
                                <Link className="navbar-brand text-white navbar-title" to={currentPilet.homePath}>
                                    {currentPilet.prettyName}
                                </Link>
                            ) : ('')
                        }

                        <div className="navbar-brand justify-content-end navbar-button">

                            {isAuthenticated ?
                                <>
                                    <Container>
                                        <Row>

                                            {real_user?.roles?.includes("pu.superadmin") && (
                                                !switched ? (
                                                    <Col style={{ marginTop: 2 }}>
                                                        <SwitchInButton />
                                                    </Col>
                                                ) : (
                                                    <Col style={{ maxWidth: "80px" }}>
                                                        <SwitchOutButton />
                                                    </Col>
                                                )
                                            )}

                                            <Col style={{ maxWidth: "80px" }}>
                                                {children}
                                            </Col>
                                            <Col style={{ maxWidth: "100px" }}>
                                                <SignOutButton />
                                            </Col>
                                        </Row>
                                    </Container>
                                </>
                                : <SignInButton />}
                        </div>
                    </div>
                </nav>
                {(currentPilet?.menuItems && currentPilet.menuItems.length > 0) && (
                    <nav className="navbar navbar-light navbar-expand-lg navbar-toggleable-lg ng-white box-shadow">
                        <div className="container">
                            <div className="navbar-collapsable" id="navbarNav">
                                <div className="menu-wrapper">
                                    <ul className="navbar-nav justify-content-start" style={{ paddingLeft: '12px', fontSize: '18px' }}>
                                        {[...currentPilet.menuItems]
                                            .sort((a, b) => (a.order || 0) - (b.order || 0))
                                            .map((item, index) => {
                                                if (item.children && item.children.length > 0) {
                                                    return (<Dropdown
                                                        key={index}
                                                        inNavbar
                                                        tag="li"
                                                        className="nav-item dropdown"
                                                    >
                                                        <DropdownToggle
                                                            className="nav-link dropdown-toggle"
                                                            tag="a"
                                                            data-bs-toggle="dropdown"
                                                        >
                                                            <span>{item.title}</span>
                                                            <Icon icon="it-expand" size="xs" />
                                                        </DropdownToggle>

                                                        <DropdownMenu className="text-nowrap">
                                                            <LinkList>
                                                                {item.children.map((child, childIndex) => (
                                                                    <LinkListItem key={childIndex} href="#">
                                                                        <Link className="nav-link" to={child.path}>
                                                                            <span>{child.title}</span>
                                                                        </Link>
                                                                    </LinkListItem>
                                                                ))}
                                                            </LinkList>
                                                        </DropdownMenu>
                                                    </Dropdown>);
                                                }

                                                return (
                                                    <li key={index} className="nav-item">
                                                        <Link className="nav-link" to={item.path}>
                                                            <span>{item.title}</span>
                                                        </Link>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </nav>
                )}
            </header >
        );
    },
    NotificationsHost: ({ children }) => <div className="notifications">{children}</div>,
    NotificationsToast: ({ options, onClose, children }) => (
        <div className={`notification-toast ${options.type}`}>
            <div className="notification-toast-details">
                {options.title && <div className="notification-toast-title">{options.title}</div>}
                <div className="notification-toast-description">{children}</div>
            </div>
            <div className="notification-toast-close" onClick={onClose} />
        </div>
    ),
    // Router: ({ children }) => (
    //     <BrowserRouter basename='/piattaforma-unica/'>{children}</BrowserRouter>
    // )
};

